import * as R from 'ramda'

import extendsSchema from 'coact/utils/schema/extendsSchema'
import toSchemaPath from 'coact/utils/schema/toSchemaPath'

import invoiceSchema from '~/src/invoice/data/invoices/schema.js'
import twInvoiceSchema from '~/src/invoice/twInvoice/data/schema.js'

import formatterAndViewOfSrc from './formatterAndViewOfSrc.js'

const putTwInvoiceSchema = R.assocPath(toSchemaPath('invoice'), twInvoiceSchema)
const addFormatterAndViewOfSrc = R.over(R.lensPath(toSchemaPath('src')), f => ({
  ...f,
  ...formatterAndViewOfSrc,
}))
const addOptinosOfCarrier = R.over(
  R.lensPath(toSchemaPath('invoice.carrier.type')),
  f => ({
    ...f,
    options: ['mobile', 'CPC'],
    formatter: value => {
      const dict = {
        mobile: '手機條碼',
        CPC: '自然人憑證',
      }
      return dict[value] || value
    },
  }),
)
const addDateFormat = schema =>
  extendsSchema(schema, ({ type }) =>
    type === 'Date' ? { format: 'YYYY-MM-DD HH:mm:ss' } : {},
  )

const schema = R.pipe(
  putTwInvoiceSchema,
  addFormatterAndViewOfSrc,
  addOptinosOfCarrier,
  addDateFormat,
)(invoiceSchema)

export default schema
